/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PolicyCategory } from './PolicyCategory';
import {
    PolicyCategoryFromJSON,
    PolicyCategoryFromJSONTyped,
    PolicyCategoryToJSON,
    PolicyCategoryToJSONTyped,
} from './PolicyCategory';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface GetPolicyResponse
 */
export interface GetPolicyResponse {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof GetPolicyResponse
     */
    policyId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof GetPolicyResponse
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof GetPolicyResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GetPolicyResponse
     */
    displayText: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetPolicyResponse
     */
    isRequired: boolean;
    /**
     * 
     * @type {PolicyCategory}
     * @memberof GetPolicyResponse
     */
    category: PolicyCategory | null;
    /**
     * 
     * @type {Date}
     * @memberof GetPolicyResponse
     */
    acceptedAt?: Date | null;
}



/**
 * Check if a given object implements the GetPolicyResponse interface.
 */
export function instanceOfGetPolicyResponse(value: object): value is GetPolicyResponse {
    if (!('policyId' in value) || value['policyId'] === undefined) return false;
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('displayText' in value) || value['displayText'] === undefined) return false;
    if (!('isRequired' in value) || value['isRequired'] === undefined) return false;
    if (!('category' in value) || value['category'] === undefined) return false;
    return true;
}

export function GetPolicyResponseFromJSON(json: any): GetPolicyResponse {
    return GetPolicyResponseFromJSONTyped(json, false);
}

export function GetPolicyResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPolicyResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'policyId': ApiUserTasksGetPageParameterFromJSON(json['policyId']),
        'key': json['key'],
        'name': json['name'],
        'displayText': json['displayText'],
        'isRequired': json['isRequired'],
        'category': PolicyCategoryFromJSON(json['category']),
        'acceptedAt': json['acceptedAt'] == null ? undefined : (new Date(json['acceptedAt'])),
    };
}

export function GetPolicyResponseToJSON(json: any): GetPolicyResponse {
    return GetPolicyResponseToJSONTyped(json, false);
}

export function GetPolicyResponseToJSONTyped(value?: GetPolicyResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'policyId': ApiUserTasksGetPageParameterToJSON(value['policyId']),
        'key': value['key'],
        'name': value['name'],
        'displayText': value['displayText'],
        'isRequired': value['isRequired'],
        'category': PolicyCategoryToJSON(value['category']),
        'acceptedAt': value['acceptedAt'] == null ? value['acceptedAt'] : value['acceptedAt'].toISOString(),
    };
}

